import { InjectionToken } from '@angular/core';

export interface ChunkLoadRecovery {
  clearReloadMarker(): void;
  handleChunkLoadFailure(): void;
}

export const CHUNK_LOAD_RECOVERY = new InjectionToken<ChunkLoadRecovery>(
  'CHUNK_LOAD_RECOVERY',
);
